import { create } from "zustand";
import { User } from "../models/User";
import { ProjectInfo } from "../models/ProjectForm";
import authService from "../services/auth/auth.service";
import { CustomAlertProps } from "../models/Alerts";
import http from "../services/httpRequest";


interface GlobalState {
  user?: User;
  setUser: (user: User) => void;
  isLogged: boolean|undefined;
  setIsLogged: (isLogged: boolean) => void;
  authorizeUser: () => void;

  project?: ProjectInfo;
  setProject: (project: ProjectInfo) => void;

  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  loadingMessage: string|undefined;

  uploadProgress?: number;
  resetUploadProgress: () => void;
  setUploadProgress: (progress: number) => void;

  alert: CustomAlertProps;
  showAlert: boolean;
  setAlert: (message:any , type: any, permanent?:boolean) => void;
  clearAlert: () => void;
}

const useGlobalState = create<GlobalState>((set) => {
  const authorizeUser = async () => {
    let resp = await authService.me()
    if (resp) {
      set({ user: resp.user, isLogged: true });
      return true;
    } else {
      set({ isLogged: false });
      return false;
    }
  }

  const setIsLogged = (isLogged: boolean) => {
    set({ isLogged })
  }

  const setProject = (project: ProjectInfo) => {
    set({ project })
  }

  const resetUploadProgress = () => {
    set({ uploadProgress: undefined });
  }

  const setUploadProgress = (progress: number) => {
    set({ uploadProgress: progress });
  }

  const setAlert = (message:string, type: any, permanent = false) => {
    set({
      alert: {
        message: message,
        type: type
      } as CustomAlertProps,
      showAlert: true
    })
    
    if (permanent) return;
    setTimeout(() => {
      clearAlert()
    }, 7000);
  }

  const clearAlert = () => {
    set({
      alert: {} as CustomAlertProps,
      showAlert: false
    });
  }

  const showLoader = (message?: string) => {
    setTimeout(() => {
      set({
        loadingMessage: message,
        isLoading: true
      });
    }, 0);
  }

  const clearLoader = () => {
    setTimeout(() => {
      set({
        loadingMessage: undefined,
        isLoading: false
      });
    }, 300);
  }

  http.apiResponse.showError = setAlert;
  http.apiResponse.setUploadProgress = setUploadProgress;
  http.apiResponse.resetUploadProgress = resetUploadProgress;
  http.apiResponse.showLoader = showLoader;
  http.apiResponse.clearLoader = clearLoader;

  return ({
    user: undefined,
    setUser: (user: User) => set({ user }),
    isLogged: undefined,
    setIsLogged: setIsLogged,
    authorizeUser: authorizeUser,
  
    project: undefined,
    setProject: setProject,
  
    isLoading: false,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),
    loadingMessage: undefined,

    uploadProgress: undefined,
    resetUploadProgress: resetUploadProgress,
    setUploadProgress: setUploadProgress,

    alert: {message: "Hola! Bienvenido a Emprendeodres UABC"} as CustomAlertProps,
    showAlert: false,
    setAlert: setAlert,
    clearAlert: clearAlert,
  })
});

export default useGlobalState